import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import emailSuccessImage from '../../../../assets/images/graphics/email-success.svg';

type SuccessNoticeProps = {
  navigateToSignIn: () => void;
};

export const SuccessNotice = ({
  navigateToSignIn,
}: SuccessNoticeProps) => (
  <Paper
    elevation={0}
    variant='outlined'
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      p: 4,
      maxWidth: 440,
      width: '100%',
      borderRadius: '24px',
      bgcolor: '#ffffff',
      boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.08)',
      textAlign: 'center',
    }}
  >
    <Box
      component='img'
      src={emailSuccessImage}
      alt='email-verify'
      sx={{ width: 220, mb: 3 }}
    />
    <Typography
      variant='h5'
      sx={{
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '-0.01em',
        color: 'text.primary',
        mb: 1.5,
      }}
    >
      Email Verification Successful!
    </Typography>
    <Typography variant='body2' sx={{ color: 'text.secondary' }}>
      <Link
        component='button'
        variant='body2'
        onClick={navigateToSignIn}
        sx={{ fontWeight: 600, color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
      >
        Click Here
      </Link>
      &nbsp;to Log-in to your account.
    </Typography>
  </Paper>
);

